import { API_URL, GRAPHQL_API_URL } from '../../config';
const initialState = {
    builderURL: 'http://localhost:3000',
    apiURL: API_URL,
    graphqlApiURL: GRAPHQL_API_URL,
    settingsWindowVisible: false,
    hostInfo: {
        head: ['TYPE', 'HOST', 'VALUE'],
        body: [
            ['A', '@', '174.138.116.26'],
            ['CNAME', 'www', 'your_domain'],
        ],
    },
};

export default function config(state = initialState, action) {
    switch (action.type) {
        case 'settingsWindowVisible': {
            return {
                ...state,
                settingsWindowVisible: true,
            };
        }
        case 'hideSettingsWindow': {
            return {
                ...state,
                settingsWindowVisible: false,
            };
        }
        default:
            return state;
    }
}
